"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.renderCloud = renderCloud;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var d3 = _interopRequireWildcard(require("d3"));

var _d3Cloud = _interopRequireDefault(require("d3-cloud"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var RootSvg = _styledComponents.default.svg.withConfig({
  displayName: "WordCloud__RootSvg",
  componentId: "sc-1gugmu1-0"
})(["& text{cursor:", ";}& text:hover{", ";}"], function (_ref) {
  var isClickable = _ref.isClickable;
  return isClickable ? 'pointer' : 'default';
}, function (_ref2) {
  var theme = _ref2.theme,
      isClickable = _ref2.isClickable;
  return isClickable ? "fill: ".concat(theme.main.secondary, ";") : '';
});

var BASE_HEIGHT = 900;
var BASE_FONT_MIN = 20;
var BASE_FONT_MAX = 150;

function determineColor(highlightedWords, theme, inverted) {
  var baseColor = inverted ? theme.inverted.one[0] : theme.one[0];
  return function (word) {
    return highlightedWords.indexOf(word.text) !== -1 ? theme.main.primary : baseColor;
  };
}

function renderCloud(width, height, wordFrequencies, theme, domain, canvas) {
  var list = wordFrequencies.map(function (r) {
    return {
      text: r.topWord,
      size: r.count
    };
  }); // Establish domain based on prop or data itself

  if (!domain) {
    var maxSize = d3.max(list, function (d) {
      return d.size;
    });
    var minSize = d3.min(list, function (d) {
      return d.size;
    });
    domain = [minSize, maxSize];
  } // Make font scale to map data to predefined size (matching canvas)


  var fontScale = d3.scaleLinear().domain(domain).range([BASE_FONT_MIN, BASE_FONT_MAX]); // Size canvas to match ratio of input width/height
  // (we wish to stick to a predefined ratio between fonts and canvas)

  var baseWidth = BASE_HEIGHT * (height / width); // Render cloud

  return new Promise(function (resolve) {
    var instance = (0, _d3Cloud.default)().size([BASE_HEIGHT, baseWidth]).words(list).overflow(true).padding(5).rotate(0).font(theme.font2).fontSize(function (word) {
      return fontScale(word.size);
    }).on('end', function (words) {
      // Return results merged onto corresponding wordFrequencies
      var merged = words.map(function (w, i) {
        return _objectSpread(_objectSpread({}, w), wordFrequencies[i]);
      });
      resolve(merged);
    });

    if (canvas) {
      instance.canvas(canvas);
    }

    instance.start();
  });
}

function hasCoordinates(words) {
  return words && words.length > 0 && words[0].x != null;
}

var WordCloud = function WordCloud(props) {
  var width = props.width,
      height = props.height,
      onWordClick = props.onWordClick,
      highlightedWords = props.highlightedWords,
      theme = props.theme,
      inverted = props.inverted,
      domain = props.domain,
      canvas = props.canvas;
  var isClickable = onWordClick != null;
  var color = determineColor(highlightedWords, theme, inverted);

  var _useState = (0, _react.useState)(props.words),
      _useState2 = _slicedToArray(_useState, 2),
      words = _useState2[0],
      setWords = _useState2[1];

  (0, _react.useEffect)(function () {
    if (words.length > 0 && !hasCoordinates(words)) {
      renderCloud(width, height, words, theme, domain, canvas).then(function (renderedWords) {
        return setWords(renderedWords);
      });
    }
  });

  if (hasCoordinates(words)) {
    // Prepare opacity scale
    var opacityMax = BASE_FONT_MAX * 0.45; // Give full opacity to anything higher than 45% of max size

    var opacityScale = d3.scaleLinear().domain([BASE_FONT_MIN, opacityMax]).range([0.4, 1.0]); // Compute viewBox
    // Zoom render such that all words are visible, this is done by collecting coordinates
    // of words closest to the edge (i.e. left-most word dictates the left edge of the box)

    var minX = d3.min(words.map(function (w) {
      return w.x - w.width / 2;
    }));
    var maxX = d3.max(words.map(function (w) {
      return w.x + w.width / 2;
    }));
    var minY = d3.min(words.map(function (w) {
      return w.y - w.height / 2;
    }));
    var maxY = d3.max(words.map(function (w) {
      return w.y + w.height / 2;
    }));
    var widthBox = maxX - minX;
    var heightBox = maxY - minY;
    var viewBox = "".concat(minX, " ").concat(minY, " ").concat(widthBox, " ").concat(heightBox); // Render texts

    var texts = words.map(function (word, i) {
      return /*#__PURE__*/_react.default.createElement("text", {
        key: i,
        x: word.x,
        y: word.y,
        fontFamily: theme.font2,
        fontSize: word.size,
        fill: color(word),
        fillOpacity: opacityScale(word.size),
        textAnchor: "middle",
        onClick: isClickable ? function () {
          return onWordClick(word.text);
        } : null
      }, word.text);
    });
    return /*#__PURE__*/_react.default.createElement(RootSvg, {
      width: width,
      height: height,
      viewBox: viewBox,
      isClickable: isClickable
    }, texts);
  }

  return null;
};

WordCloud.renderCloud = renderCloud;
WordCloud.propTypes = {
  words: _propTypes.default.arrayOf(_propTypes.default.shape({
    topWord: _propTypes.default.string.isRequired,
    count: _propTypes.default.number.isRequired,
    text: _propTypes.default.string,
    size: _propTypes.default.number,
    x: _propTypes.default.number,
    y: _propTypes.default.number,
    width: _propTypes.default.number,
    height: _propTypes.default.number
  })).isRequired,
  domain: _propTypes.default.arrayOf(_propTypes.default.number),
  width: _propTypes.default.number,
  height: _propTypes.default.number,
  onWordClick: _propTypes.default.func,
  highlightedWords: _propTypes.default.arrayOf(_propTypes.default.string),
  inverted: _propTypes.default.bool
};
WordCloud.defaultProps = {
  highlightedWords: [],
  inverted: false
};

var _default = (0, _styledComponents.withTheme)(WordCloud);

exports.default = _default;
//# sourceMappingURL=WordCloud.js.map